import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "@mango/authentication";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class IpCheckService {
  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {}

    private cachedUserId?: string;
    private cachedResult?: boolean;

    isAllowed(): Observable<boolean> {
        const userId = this.authenticationService.currentUser.id;

        if (this.cachedUserId === userId && this.cachedResult !== undefined) {
            return of(this.cachedResult);
        }

        return this.http.get<{ allowed: boolean }>('api/auth/ipcheck').pipe(
            map(result => {
                this.cachedResult = result.allowed;
                this.cachedUserId = userId;
                return result.allowed;
            })
        );
    }
}
